import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm sm:text-base"
}
const _hoisted_2 = {
  key: 0,
  class: "py-2 border-gray-200 border-b"
}
const _hoisted_3 = { class: "flex items-center justify-between px-4 py-2" }
const _hoisted_4 = { class: "font-semibold text-sm text-gray-500 whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_layout_auth_sidebar_content_menu = _resolveComponent("layout-auth-sidebar-content-menu")!

  return (_ctx.toArray(_ctx.store.state.menu.menuCategories).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.state.menu.menuCategories, (category) => {
            return (_openBlock(), _createElementBlock("li", {
              key: category.id
            }, [
              (_ctx.toArray(category.menus).length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(category.name), 1)
                    ]),
                    _createVNode(_component_layout_auth_sidebar_content_menu, {
                      menus: category.menus
                    }, null, 8, ["menus"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}